"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var react_2 = __importDefault(require("react"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var polished_1 = require("polished");

var closeButton = function closeButton(props) {
  return (0, react_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 50px;\n\theight: 50px;\n\tborder-left: 1px solid ", ";\n"])), (0, polished_1.rgba)(props.color, 0.1));
};

var closeButtonWrapper = function closeButtonWrapper(props) {
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tbackground-color: ", ";\n"])), props.color);
};

var mainContainerStyles = function mainContainerStyles(props) {
  return (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tleft: ", ";\n\ttop: ", "px;\n\tz-index: ", ";\n\twidth: 100%;\n\tposition: absolute;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tdisplay: ", ";\n"])), props.left, props.top, props.zIndex, props.isActive ? "block" : "none");
};

var overlayStyle = function overlayStyle(props) {
  return (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tbox-shadow: -5px 8px 13px -1px rgba(0, 0, 0, 0.32);\n\tposition: relative;\n\tz-index: ", ";\n"])), props.background, props.zIndex);
};

var MobileWindowOverlay = function MobileWindowOverlay(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? "" : _a$className,
      _a$left = _a.left,
      left = _a$left === void 0 ? 0 : _a$left,
      _a$top = _a.top,
      top = _a$top === void 0 ? 0 : _a$top,
      _a$zIndex = _a.zIndex,
      zIndex = _a$zIndex === void 0 ? 1 : _a$zIndex,
      handleClose = _a.handleClose,
      props = __rest(_a, ["className", "left", "top", "zIndex", "handleClose"]);

  var _ref = (0, frontend_theme_1.useTheme)(),
      theme = _ref.theme;

  var _theme$colors$primary = theme.colors.primary,
      lighterGray = _theme$colors$primary.lighterGray,
      darkGray = _theme$colors$primary.darkGray,
      white = _theme$colors$primary.white;
  react_2.default.useEffect(function () {}, []);
  return (0, jsx_runtime_1.jsx)("div", {
    css: mainContainerStyles({
      left: left,
      top: top,
      zIndex: zIndex,
      isActive: true
    }),
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: className,
      direction: "column",
      style: overlayStyle({
        zIndex: zIndex,
        background: lighterGray
      }),
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: "flex-end",
        style: closeButtonWrapper({
          color: darkGray
        }),
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          justifyContent: "center",
          alignItems: "center",
          style: closeButton({
            color: white
          }),
          onClick: function onClick() {
            return handleClose();
          },
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: "close",
            size: "sm",
            onClick: function onClick() {
              return handleClose();
            },
            color: white
          })
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        css: {
          margin: "10px 20px 40px 20px",
          width: "auto"
        },
        children: props.children
      })]
    })
  });
};

exports.default = MobileWindowOverlay;